exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_holder .model_button_holder{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:end;align-items:flex-end;padding-top:20px}.modal_holder button{border:1.2px solid var(--text-light-blue);background-color:#fff;border-radius:15px !important;width:auto;padding:6px 14px;font-size:14px;display:block}.modal_holder button:hover{color:#fff;background-color:var(--text-light-blue)}@media screen and (max-width: 375px){.ReactModal__Content{inset:40px 40px 40px 10% !important;width:300px !important}}@media screen and (min-width: 376px) and (max-width: 425px){.ReactModal__Content{inset:40px 40px 40px 15% !important;width:300px !important}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/modal/modal.scss
// module id = 854
// module chunks = 0